// extracted by mini-css-extract-plugin
export var askAiIcon = "_mw-9";
export var container = "_mw-0";
export var groupSeparator = "_mw-a";
export var highlight = "_mw-4";
export var resultIcon = "_mw-5";
export var resultItem = "_mw-7";
export var resultSubtitle = "_mw-3";
export var resultTitle = "_mw-2";
export var resultsList = "_mw-1";
export var searchGroup = "_mw-6";
export var selected = "_mw-8";